import React from 'react'
import Text from '../text/Text'
import CircleImage from '../../assets/images/subscription/circle.png'

interface BussinesElementComponent {
    title: string
    content: string
    subtitle: string
}

export function BussinesElement(properties: BussinesElementComponent) {
    return (
        <div
            style={{
                backgroundImage: `url(${CircleImage})`,
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain',
                width: 75,
                height: 75,
                minWidth: 75,
                maxWidth: 75,
                minHeight: 75,
                maxHeight: 75,
                backgroundColor: '#FFF',
                borderRadius: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
            }}
        >
            <Text
                label={properties.title}
                fontWeight={500}
                color="#7F898F"
                fontSize={6}
            />
            <Text
                label={properties.content}
                fontSize={10}
                color="#010F19"
                fontWeight={600}
            />
            <Text
                label={properties.subtitle}
                fontWeight={500}
                color="#7F898F"
                fontSize={6}
            />
        </div>
    )
}
